var rtlStyles = {"rtl":"NrHpn","ltr":"t077n"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-ce9896a6.js.map
